import React from "react";

import { Main } from "./Main";



const App = () => (
    <div className="App">
      <Main />
    </div>
)

export default App;
